var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoOrangeMoney(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 4,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8105 9.54492H5.32085C4.48125 9.54492 3.80047 10.236 3.80047 11.0889C3.80047 11.9418 4.48072 12.6318 5.32085 12.6318H9.13979L2.9921 18.8729C2.39814 19.4759 2.39814 20.4529 2.9921 21.0559C3.58607 21.6588 4.54848 21.6588 5.14244 21.0559L11.2896 14.8154V18.6918C11.2896 19.5441 11.9704 20.2358 12.8105 20.2358C13.6506 20.2358 14.3309 19.5446 14.3309 18.6918V11.0884C14.3309 10.236 13.6506 9.54492 12.8105 9.54492Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1892 20.1697H24.6789C25.5185 20.1697 26.1998 19.4785 26.1998 18.6262C26.1998 17.7739 25.519 17.0822 24.6789 17.0822H20.8605L27.0076 10.8423C27.6016 10.2393 27.6016 9.26225 27.0076 8.65927C26.4136 8.05629 25.4512 8.05629 24.8573 8.65927L18.7101 14.8992V11.0228C18.7101 10.1705 18.0293 9.47937 17.1897 9.47937C16.3501 9.47937 15.6688 10.1705 15.6688 11.0228V18.6262C15.6688 19.4791 16.3496 20.1697 17.1892 20.1697Z",
    fill: "#FF7900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoOrangeMoney);
export default __webpack_public_path__ + "static/media/logoOrangeMoney.c805a0a524034447811d95a8f8754710.svg";
export { ForwardRef as ReactComponent };